﻿import React from 'react';
import { AirportDelay, FlightConstrainedArea, RerouteAdvisory } from '../components/constraints-list/types';
import constraintsStore from './constraints-store';

const useConstraintsStore = () => {
    const [rerouteAdvisories, setRerouteAdvisories] = React.useState<RerouteAdvisory[]>(() => constraintsStore.getRerouteAdvisories());
    const [airportDelays, setAirportDelays] = React.useState<AirportDelay[]>(() => constraintsStore.getAirportDelays());
    const [flightConstrainedAreas, setFlightConstrainedAreas] = React.useState<FlightConstrainedArea[]>(() =>
        constraintsStore.getFlightConstrainedAreas()
    );

    const [lastRerouteUpdate, setLastRerouteUpdate] = React.useState(() => constraintsStore.getLastRerouteUpdate());
    const [lastAirportDelayUpdate, setLastAirportDelayUpdate] = React.useState(() => constraintsStore.getLastAirportDelayUpdate());
    const [lastFlightConstrainedAreaUpdate, setLastFlightConstrainedAreaUpdate] = React.useState(() =>
        constraintsStore.getLastFlightConstrainedAreaUpdate()
    );

    React.useEffect(() => {
        const callback = () => {
            setRerouteAdvisories([...constraintsStore.getRerouteAdvisories()]);
            setAirportDelays([...constraintsStore.getAirportDelays()]);
            setFlightConstrainedAreas([...constraintsStore.getFlightConstrainedAreas()]);

            setLastRerouteUpdate(constraintsStore.getLastRerouteUpdate());
            setLastAirportDelayUpdate(constraintsStore.getLastAirportDelayUpdate());
            setLastFlightConstrainedAreaUpdate(constraintsStore.getLastFlightConstrainedAreaUpdate());
        };

        constraintsStore.onUpdated(callback);
        return () => constraintsStore.offUpdated(callback);
    }, []);

    const fetchConstraints = React.useCallback(async () => {
        await constraintsStore.fetchConstraintsNow();
    }, []);

    return {
        rerouteAdvisories,
        airportDelays,
        flightConstrainedAreas,
        lastRerouteUpdate,
        lastAirportDelayUpdate,
        lastFlightConstrainedAreaUpdate,
        fetchConstraints
    };
};

export default useConstraintsStore;
